import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { LocationDetails } from './locations-details';



export class AllLocationResponseModel extends GlobalResponseObject{
    data?: LocationDetails[];
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: LocationDetails[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}
 